<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
defineProps({
  title: { type: String, default: '' },
  description: { type: String, default: '' },
  icon: { type: String, default: 'i-lucide-users' },
  actionLabel: { type: String, default: '' },
  critical: { type: Boolean, default: false },
});

const emit = defineEmits(['action']);
</script>

<template>
  <div
    class="mx-auto grid max-w-sm justify-items-center gap-3 rounded-lais border border-dashed border-lais-border bg-lais-bg-soft px-6 py-10 text-center"
  >
    <span
      class="grid size-12 place-items-center rounded-full bg-white"
      :class="critical ? 'text-lais-danger' : 'text-lais-primary'"
    >
      <span class="size-6" :class="icon" aria-hidden="true" />
    </span>
    <div>
      <p class="text-[14px] font-semibold text-lais-text">{{ title }}</p>
      <p class="mt-1 text-[13px] text-lais-text-muted">{{ description }}</p>
    </div>
    <button
      v-if="actionLabel"
      type="button"
      class="rounded-lais border border-lais-border bg-white px-4 py-2 text-[13px] font-semibold text-lais-primary hover:border-lais-primary"
      @click="emit('action')"
    >
      {{ actionLabel }}
    </button>
  </div>
</template>
